import type { ActivityLogOut } from '@repo/api-codegen';
import { useMemo } from 'react';
import {
	ActivityLogEventBlocksRender,
	ActivityLogResourceRender,
} from '../AuditLog/render';
import { DateRenderer } from '../CatalogView/TableView/DateRenderer';
import type { ExtendedDataTableColumn } from '../TableV2/types';

export function useColumns(): ExtendedDataTableColumn<ActivityLogOut>[] {
	const columns = useMemo(
		() => [
			{
				accessor: 'updated_at',
				titleLabel: 'Date',
				render: (record: ActivityLogOut) => (
					<DateRenderer value={record?.logged_at} />
				),
			},
			{
				accessor: 'resource_id',
				titleLabel: 'Resource',
				render: (record: ActivityLogOut) => (
					<ActivityLogResourceRender record={record} />
				),
			},
			{
				accessor: 'event_blocks',
				titleLabel: 'Event',
				render: (record: ActivityLogOut) => (
					<ActivityLogEventBlocksRender blocks={record.event_blocks} />
				),
			},
		],
		[]
	);

	return columns;
}
